import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import messages from './messages'

class LanguageControllerResponsive extends Component {
  constructor(props) {
    super(props)
    const {
      intl: { formatMessage }
    } = props
    this.formatMessage = formatMessage
    this.closeMenuOffCanvas = props.closeMenuOffCanvas
    this.select = React.createRef()
  }
	setLanguage = event => {
	  this.props.fn(event.target.getAttribute('value'))
	  this.closeMenuOffCanvas()
	}

	getLanguageFullName = lang => {
	  switch (lang) {
	  case 'es':
	    return this.formatMessage(messages.espanol)
	  case 'eu':
	    return this.formatMessage(messages.euskera)
	  case 'en':
	    return this.formatMessage(messages.english)
	  default:
	  }
	}
	showLanguages = () => {
	  let buffer = []
	  const availableLanguages = ['es', 'eu', 'en']
	  let { selectedLanguage } = this.props

	  availableLanguages.forEach(lang => {
	    if (lang !== selectedLanguage) {
	      buffer.push(
	        <li key={lang}>
	          <a value={lang} onClick={this.setLanguage}>
	            {this.getLanguageFullName(lang)}
	          </a>
	        </li>
	      )
	    }
	  })
	  return buffer
	}
	render() {
	  return <ul className="ork-menu-off-canvas__languages ork-menu-off-canvas__block">{this.showLanguages()}</ul>
	}
}

export default injectIntl(LanguageControllerResponsive)



// WEBPACK FOOTER //
// ./src/modules/Controllers/Language/LanguageControllerResponsive/LanguageControllerResponsive.jsx